export type Colors = typeof defaultColors;

export const defaultColors = {
  primary: '#FFB224',
  white: '#fff',
  typography: {
    soft: '#9BA1A6',
    primary: '#FFB224',
    black: '#000',
  },
  border: {
    default: '#697177',
    soft: '#313538',
  },
  surface: {
    default: '#697177',
  },
  line: {
    default: '#FFB224',
  },
  bars: {
    up: '#63C174',
    down: '#F16A50',
  },
  multi: {
    tomatoDark: '#E54D2E',
    redDark: '#E5484D',
    crimsonDark: '#E93D82',
    pinkDark: '#D6409F',
    plumDark: '#AB4ABA',
    purpleDark: '#8E4EC6',
    violetDark: '#6E56CF',
    indigoDark: '#3E63DD',
    blueDark: '#0091FF',
    cyanDark: '#05A2C2',
    tealDark: '#12A594',
    greenDark: '#46A758',
    grassDark: '#46A758',
    orangeDark: '#F76808',
    brownDark: '#AD7F58',
    skyDark: '#68DDFD',
    mintDark: '#70E1C8',
    limeDark: '#99D52A',
    yellowDark: '#F5D90A',
  },
};
